import React from "react";

const AboutOurFounder = () => {
  return (
    <div className="about__tab_p">
      <h4>About Our Founder </h4>
      <p>
        Nedim is a graduate of Boğaziçi University, Department of Computer
        Engineering. He completed his Marketing-focused MBA at the University of
        Iowa. He was awarded the 3rd prize in the competition in the field of
        Marketing organized by the University of Rochester among MBA programs
        across America.
      </p>
      <p>
        He worked at the headquarters of PricewaterhouseCoopers, Vodafone and
        Avon companies in Turkey, which are the leading international companies
        in their sectors. He worked abroad at the headquarters of Orbitz, one of
        the largest online travel agencies in America, and Microsoft, one of the
        world's largest companies in software. He gained extensive experience
        from technology to internet, from process improvement to risk analysis
        and from marketing to strategy in the companies he worked for.
      </p>
      <p>
        He founded the Next Generation company in 2009 to realize his knowledge
        and experience in business and education life with internet projects in
        Turkey.
      </p>
    </div>
  );
};

export default AboutOurFounder;
